import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("详细数据")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("   ")

import {ref, onMounted, reactive, watch} from "vue";
import Datatable from "@/components/kt-datatable/Datatable3.vue";
import { parseTime } from '@/utils'
import Digram from "./CollectionDigram.vue";
import ApiService from "@/core/services/ApiService";
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  props: {
  tab: { type: String, required: true },
},
  setup(__props) {

const props = __props



const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'm/collection/utm';
const d = new Date();
d.setDate(d.getDate() - 7);
const tableHeader = ref([
  { name: "日期", key: "date", sortable: true },
  { name: "日志目录", key: "site" },
  { name: "媒介", key: "medium", sortable: true },
  { name: "来源", key: "source", sortable: true },
  { name: "系列", key: "campaign", sortable: true },
  { name: "数量", key: "count", sortable: true },
  { name: "用户数", key: "user_count", sortable: true },
]);
const filters = reactive({
  medium: '',
  source: '',
  campaign: '',
  start_date: parseTime(d, "{y}-{m}-{d}"),
  stop_date: parseTime(new Date(), "{y}-{m}-{d}"),
});
const start_stop_date = ref<any>([
  filters.start_date,
  filters.stop_date
]);
const shortcuts = [
  {
    text: '昨天',
    value: () => {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return [date, date]
    },
  },
  {
    text: '最近7天',
    value: () => {
      const date = new Date()
      date.setDate(date.getDate() - 7)
      return [date, new Date()]
    },
  },
  {
    text: '最近15天',
    value: () => {
      const date = new Date()
      date.setDate(date.getDate() - 15)
      return [date, new Date()]
    },
  },
  {
    text: '最近30天',
    value: () => {
      const date = new Date()
      date.setDate(date.getDate() - 30)
      return [date, new Date()]
    },
  },
]
const chartData = ref<any[]>([]);

onMounted(() => {
});

watch(props, (val) => {
  if (props.tab === '用户来源'){
    loadData();
  }
});

const loadData = () => {
  ApiService.get(apiUrl + '/daily', filters).then(({data}) => {
    chartData.value = data;
  });
  (dataT as any).value.setCurrent(1);
}

const changeDate = function(v) {
  let s = new Date(v[0]);
  let e = new Date(v[1]);
  s.setDate(s.getDate() + 180);
  if (e < s) {
    filters.start_date = v[0];
    filters.stop_date = v[1];
    loadData();
  } else {
    ElMessage.warning('筛选范围过大会导致浏览器卡顿，请缩小范围查询！');
  }
}

const loadHeader = (func) => {
  return true;
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: _unref(filters).medium,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).medium) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (loadData()), ["enter"])),
            clearable: "",
            placeholder: "请输入媒介",
            size: "small",
            style: {"width":"120px"}
          }, null, 8, ["modelValue"]),
          _hoisted_4,
          _createVNode(_component_el_input, {
            modelValue: _unref(filters).source,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).source) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (loadData()), ["enter"])),
            clearable: "",
            placeholder: "请输入来源",
            size: "small",
            style: {"width":"120px"}
          }, null, 8, ["modelValue"]),
          _hoisted_5,
          _createVNode(_component_el_input, {
            modelValue: _unref(filters).campaign,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).campaign) = $event)),
            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (loadData()), ["enter"])),
            clearable: "",
            placeholder: "请输入来源",
            size: "small",
            style: {"width":"180px"}
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: "el-icon-search",
                size: "small",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (loadData()))
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_date_picker, {
            modelValue: start_stop_date.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((start_stop_date).value = $event)),
            type: "daterange",
            "range-separator": "到",
            "value-format": "YYYY-MM-DD",
            size: "small",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            clearable: false,
            onChange: changeDate,
            shortcuts: shortcuts
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(Digram, { data: chartData.value }, null, 8, ["data"]),
    _createVNode(Datatable, {
      ref_key: "dataT",
      ref: dataT,
      apiUrl: apiUrl,
      "table-header": tableHeader.value,
      filters: _unref(filters),
      title: "用户来源",
      actionMenu: false,
      preLoad: loadHeader
    }, {
      search: _withCtx(() => [
        _hoisted_7
      ]),
      toolbar: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["table-header", "filters"])
  ], 64))
}
}

})